import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleTeaser() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-600 bg-accent-50 rounded-full mb-4">
            Latest Guides
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            VigorBuy Spreadsheet Guides
          </h2>
          <p className="text-foreground-600 text-base mt-3 max-w-xl mx-auto">
            In-depth tutorials and resources to help you make the most of the VigorBuy Spreadsheet.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/guide/${article.slug}`}
              className="group bg-background-50 rounded-2xl border-2 border-background-200/70 overflow-hidden hover:border-primary-300 transition-all cursor-pointer flex flex-col"
            >
              <div className="relative h-48 overflow-hidden bg-background-100">
                <img
                  src={article.teaserImage}
                  alt={article.title}
                  title={article.title}
                  loading="lazy"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium text-primary-600 bg-background-50/90 backdrop-blur-sm rounded-full">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <p className="text-xs text-foreground-400 mb-2">{article.readTime}</p>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2 flex-1">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-500 group-hover:text-primary-600 transition-colors mt-auto">
                  Read Guide
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}